import TableUnclaimedPaymentsSynchronization from './component/TableUnclaimedPaymentsSynchronization'

export default TableUnclaimedPaymentsSynchronization